import { createContext, useContext } from 'react'

export type StoryViewerTarget =
	| { type: 'PERSONAL_STORIES'; username: string; participantUsernames: readonly string[] }
	| { type: 'STORY'; storyId: string }

interface StoryViewerContextValue {
	isStoryViewerOpen: boolean
	openStoryViewer: (target: StoryViewerTarget) => void
}

export const StoryViewerContext = createContext<StoryViewerContextValue | null>(null)

export function useStoryViewer() {
	const context = useContext(StoryViewerContext)
	if (!context) throw new Error('useStoryViewer 必须在 StoryViewerProvider 内使用')

	return context
}
